var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('div',{staticClass:"pt-4 pb-4 ps-sm-4 pe-sm-4",attrs:{"id":"header-title"}},[_c('h4',{staticClass:"text-center"},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Moto-Ya")]),_vm._v(" Training Program")],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }